import React, { Fragment } from 'react'
import { FormattedMessage } from 'sb-react-intl'
import { useField, FieldState } from 'formular'
import { useMedia, useCallback } from 'sb-hooks'
import { mixpanel, array, constants } from 'common/helpers'
import actions from 'redux/actions'

import { FormularRadioGroup, RadioButton } from 'components/_new/forms'
import { Button, buttonMessages } from 'components/_new/controls'

import Title from '../Title/Title'

import messages from './messages'
import s from './MonthlyPlanOptions.scss'

import getMore from './images/getMore.svg'


type MonthlyPlanOptionsProps = {
  goToStep: (step: string) => void
  onClose: () => void
}

const MonthlyPlanOptions: React.FunctionComponent<MonthlyPlanOptionsProps> = (props) => {
  const { goToStep, onClose } = props

  const { isMobile } = useMedia()

  const activePlanField = useField({ value: '1' })

  const upgrade = useCallback(() => {
    mixpanel.track(constants.analyticsEvents.upgradePopup, { placement: 'queue popup' })

    actions.models.upgradeSubscriptionFlow.setActiveScentIndex(Number(activePlanField.state.value))
    actions.models.upgradeSubscriptionFlow.setActiveMonthIndex(0)

    goToStep(constants.upgradeSubscriptionFlowSteps.selectedPlanSummary)
  }, [ activePlanField, goToStep ])

  return (
    <Fragment>
      <Title className={s.title} message={messages.title} />
      <FormattedMessage className={s.text} tag="div" {...messages.text} />
      {
        !isMobile && (
          <img className={s.image} src={getMore} alt="Upgrade subscription" />
        )
      }
      <FormularRadioGroup className={s.planItems} field={activePlanField}>
        {
          array.range(0, 2).map((index) => (
            <div key={index} className={s.planItem}>
              <RadioButton
                value={String(index)}
                label={{ ...messages.planItem, values: { value: index } }}
                dataTestId="upgradeMonthlyPlanOption"
              />
            </div>
          ))
        }
      </FormularRadioGroup>
      <div className={s.actions}>
        <FieldState field={activePlanField}>
          {
            ({ value }) => (
              <Button
                className={s.button}
                title={messages.upgradeButton}
                size="md"
                color="brand"
                fullWidth
                leftIcon="dollarWithStar"
                disabled={value === '0'}
                dataTestId="upgradeMonthlyPlanUpgradeButton"
                onClick={upgrade}
              />
            )
          }
        </FieldState>
        <Button
          className={s.button}
          title={buttonMessages.close}
          color="white"
          size="md"
          fullWidth
          dataTestId="upgradeMonthlyPlanCloseButton"
          onClick={onClose}
        />
      </div>
    </Fragment>
  )
}


export default MonthlyPlanOptions
